import React from 'react';

export default class Loader extends React.Component {
  getMessage = () => {
    const messages = [
      "Versuche Bilder im Bildordner wiederzufinden...",
      "Suche Notizen des letzten Meetings...",
      "Versuche Skizze von letzter Woche zu verstehen...",
      "Lese Blindtext Korrektur...",
      "Erstelle Umlaufmappe zur Freigabe der Entwürfe..."
    ]
    return messages[Math.floor(Math.random() * messages.length)];
  }
  render() {
    return (
      <div class="text-center" id="loader">
        <div className="circle-multiple">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
        <div className="loader-message m-t-20">{this.getMessage()}</div>
      </div>
    );

    /*let url = (typeof baseUrl !== 'undefined') ? baseUrl : ''
    const file = url ? 'progress' : 'chedri_loader'
 <img className="demo-mw-50" src={'/img/progress.svg'} alt="Progress"/>
    return (<div class="text-center"><img class="demo-mw-50" src={url + '/img/' + file + '.svg'} alt="Progress" /></div>)*/
  }
}
